//_api
import Login from "./Login_Register/Login";
import Permission from "./Login_Register/Permission";
import Package_Data from "./Get_Data/packages_data";
import Product from "./Product";
import Pawn from "./Pawn";
import Super_Admin from "./SuperAdmin";
import MarketPlace from "./MarketPlace";
import Report from "./Report";

const useApi = {
  login: Login,
  permission: Permission,
  packages_data: Package_Data,
  product: Product,
  super_admin: Super_Admin,
  pawn: Pawn,
  marketplace: MarketPlace,
  report: Report,
};
export default useApi;
